module.exports = __webpack_public_path__ + "static/media/TAKE-AWAY.9b5d9dae.svg";